import { useState } from 'react';
import { Button, PageHeader } from 'components';
import { Form, Row, Col, Spin } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import FileSection from './formSections/file';
import useAcademyArticles from '../useAcademyArticles';
import UIHelper from 'helpers/UIHelper';
import { useParams } from 'react-router-dom';
import FormHelper from '../../../../../helpers/FormHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  let { id } = useParams();
  const [fileReqiuredError, setFileReqiuredError] = useState([]);
  const {
    form,
    shoppingCenters,
    selectMarcoArea,
    academyCategories,
    loading,
    handleCreateOrUpdateShop,
  } = useAcademyArticles(false, id, true);
  const onFinish = async (values) => {
    await handleCreateOrUpdateShop(values, id);
  };

  const onFinishFailed = (errorInfo) => {
    setFileReqiuredError(errorInfo.errorFields[0].errors);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('CREARE RETAIL ACADEMY')
    : t('MODIFICA EXTRASTOCK CONTRACTOR');

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <Form
            form={form}
            name='basic'
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              title: '',
              shopping_center_id: '',
              academy_category_id: '',
              date: '',
              macro_area: '',
              file: [],
              in_telegram: false,
            }}
            onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <InfoSection
              shoppingCenters={shoppingCenters}
              selectMarcoArea={selectMarcoArea}
              academyCategories={academyCategories}
            />
            <FileSection fileReqiuredError={fileReqiuredError} />
          </Form>
          <Row gutter={16}>
            <Col>
              <Button
                onClick={onClickSave}
                width={'150px'}
                big
                icon={<CheckOutlined />}
                loading={loading}
              >
                {t('Invia')}
              </Button>
            </Col>
          </Row>
        </Spin>
      </div>
    </div>
  );
};

export default Edit;
